import {BBModel} from '../bb_model';

const day = {
    async query({ cItem, month, date, edate, service_id, people_ids, resource_ids, person_group_id, item }) {
        if (cItem.days_link) {
            try {
                const daysCollection = await cItem.days_link.$get('days', {
                    month, date, edate, service_id, people_ids, resource_ids, person_group_id
                });

                let days = [...daysCollection.days];

                // Filtering days that do not match specified item.
                days = days.filter(day => day.type === item);

                // Building model objects from raw data.
                days = days.map(day => new BBModel.Day(day));

                // Grouping days (time events) by date to have possibility top chose one.
                const groups = {};
                days.forEach((day) => {
                    if (groups[day.string_date]) {
                        groups[day.string_date].push(day);
                    } else {
                        groups[day.string_date] = [ day ];
                    }
                });

                // Chose one day randomly (thanks to it associated resource and person will be chosen randomly as well).
                days = Object.values(groups).map(days => getRandomDayWithAvailability(days));

                markSelectedItemAsAvailable(days, cItem);
                return days;
            } catch (error) {
                return Promise.reject(error);
            }
        } else {
            return Promise.reject('No "days" link found');
        }
    }
};

function getRandomDayWithAvailability(days) {
    // Get all days that have spaces.
    const daysWithSpaces = days.filter(day => day.spaces > 0);

    if (daysWithSpaces.length) {
        // Return a random day that has spaces.
        return daysWithSpaces[Math.floor(Math.random() * daysWithSpaces.length)];
    } else {
        // Return a day with no spaces.
        return days[0];
    }
}

function markSelectedItemAsAvailable(days, basketItem) {
    for (const day of days) {
        if ((basketItem.held && isDateValid(day, basketItem.held)) || isDateValid(day, basketItem)) {
            day.spaces = 1;
        }
    }

    function isDateValid(day, basketItem) {
        return basketItem.date && day.event_id === basketItem.event_id && day.date.isSame(basketItem.date.date);
    }
}

export {
    day
};
